// Canonical reputation-score banding. Single source of truth for the
// score -> label + colour mapping so desktop and mobile never disagree
// (a 77/100 must read the same verdict and show the same ring colour band
// everywhere it is rendered).
//
// Bands are checked high -> low; a score matches the first band whose `min`
// it meets. Colours reuse the existing design tokens (var(--pos)/--brand/
// --neg) plus the shared orange (#E08A2B) already used across the bt cards.
export const SCORE_BANDS = [
  { key: "strong", min: 80, label: "Looking strong", color: "var(--pos)" },
  { key: "healthy", min: 70, label: "Healthy", color: "var(--brand)" },
  { key: "attention", min: 55, label: "Needs attention", color: "#E08A2B" },
  { key: "risk", min: 40, label: "At risk", color: "#E08A2B" },
  { key: "critical", min: 0, label: "Critical", color: "var(--neg)" },
];

// Round internally so an unrounded desktop score and a Math.round'd mobile
// score both land on the same band.
export function scoreBand(score) {
  const v = Math.round(Number(score) || 0);
  return (
    SCORE_BANDS.find((b) => v >= b.min) ?? SCORE_BANDS[SCORE_BANDS.length - 1]
  );
}

export function scoreLabel(score) {
  return scoreBand(score).label;
}

export function scoreColor(score) {
  return scoreBand(score).color;
}
